import { MemberProfileExtendedType } from 'common/types/MemberProfile'
import { TeamSlider } from './TeamSlider'
import { getMembershipExtendedColors } from '../../common/membershipStyles'
import { useParams } from 'react-router-dom'
import { useState } from 'react'
import { useScreenSize } from 'hooks/useScreenSize'
import { AccountManager } from 'cwp-components/CWP Sections/MemberProfile/Extended/ProfileTeam/AccountManager'
import { PersonAvatar } from 'cwp-components/CWP Sections/MemberProfile/Extended/ProfileTeam/PersonAvatar'

interface ProfileTeamProps {
  profile: MemberProfileExtendedType
}

export function ProfileTeam({ profile }: ProfileTeamProps) {
  const colors = getMembershipExtendedColors(profile?.metadata.membership_type)
  const { memberEntity } = useParams()
  const showTeam =
    profile?.team && (memberEntity === 'lawfirm' || memberEntity === 'chamber')

  if (!showTeam) return null
  const [activeId, setActiveId] = useState<string>(
    profile?.team?.members?.[0]?.name,
  )

  const activeMember = profile?.team?.members.find((m) => m.name === activeId)
  const { isLg } = useScreenSize()
  return (
    <>
      <div className='mx-auto w-full max-w-[1110px] lg:min-h-[332px] h-auto'>
        <div className='flex items-center justify-center flex-wrap'>
          <AccountManager
            accountManager={profile?.team?.account_manager}
            colors={colors}
          />
          <div className='w-full flex lg:max-w-[815px] flex-col justify-end items-start '>
            <div className='w-[380px] md:w-[600px] mx-auto lg:w-full'>
              <TeamSlider
                members={
                  profile?.team?.members?.map((member, index) => ({
                    id: `team-${index}`,
                    name: member?.name || 'NA',
                    avatarUrl: member?.avatar || '',
                    avatarBg: colors?.avatarBg,
                    avatarStrokeColor: colors?.avatarStrokeColor,
                    description: member?.bio || 'NA',
                    shadow: colors?.teamMemberShadow,
                  })) ?? []
                }
                activeId={activeId}
                onChangeActiveId={setActiveId}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className={`relative lg:min-h-[300px] w-full rounded-br-2xl lg:rounded-b-[60px] p-6`}
        style={isLg ? { background: colors.teamSectionBg } : null}
      >
        <div className='mx-auto w-full relative'>
          <div className='mx-auto min-h-24 lg:min-h-[180px] flex w-[320px] lg:w-full max-w-[1110px] lg:flex-row p-5 flex-col items-start gap-5 rounded-[16px] border-[1px] border-[#D9E2F4] bg-[rgba(255,_255,_255,_0.25)] backdrop-blur-[15px] lg:flex lg:align-self-stretch'>
            <div className='flex items-center gap-x-4'>
              <PersonAvatar
                name={activeMember?.name}
                avatarUrl={activeMember?.avatar}
                avatarBg={colors?.avatarBg}
                avatarStrokeColor={colors?.avatarStrokeColor}
                avatarStrokeRotate='-rotate-[75deg]'
              />
              <p className='text-[#122D5C] text-sm font-medium leading-normal tracking-wide self-stretch lg:hidden'>
                {activeMember?.name}
              </p>
            </div>
            <div className='flex flex-col justify-center items-start gap-2 flex-[1_0_0]'>
              <p className='text-[#122D5C] text-base font-medium leading-6 tracking-wide h-6 hidden lg:block'>
                {activeMember?.name}
              </p>
              <p className='text-[#37455C] text-xs lg:text-base font-normal leading-5 tracking-wide'>
                {activeMember?.bio || 'No bio provided'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
